<template>
  <f7-popup class="EditContact">

		<page-nav-bar currentServiceName="DealPrudence" subNavTitle="Contact Edit" :closePopup="true"></page-nav-bar>

    <div class="layoutSubtitle"/>
    <f7-list form id="EditContactForm">
      <f7-list-item>
        <f7-label>Account Name</f7-label>
        <f7-input name="label" type="text" placeholder="Label" v-model="label"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>User name</f7-label>
        <f7-input name="username" placeholder="Name" type="text" v-model="username"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Identifier</f7-label>
        <f7-input name="alias" type="email" placeholder="Identifier" v-model="alias"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Iban</f7-label>
        <f7-input name="iban" type="text" placeholder="Iban" v-model="iban"></f7-input>
      </f7-list-item>
    </f7-list>

    <f7-grid no-gutter>
      <f7-col width="50">
        <f7-button
          class="button-big orangeModifyButton"
          icon-f7="gear"
          :title="$t('common.negot')"
          @click="changeContact">
          Modify
        </f7-button>
      </f7-col>
      <f7-col width="50">
        <f7-button
          class="button-big redDeleteButton"
          icon-f7="close_round"
          :title="$t('common.rm_label')"
          @click="removeContact">
          Remove
        </f7-button>
      </f7-col>
    </f7-grid>
  </f7-popup>
</template>

<script>
// import {put} from '@/helpers/api'
import {validateIBAN} from '@/helpers/validator'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'EditContact',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      alias: '',
      username: '',
      iban: '',
      label: ''
    }
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    changeContact () {
      const that = this
      var formData = this.$f7.formToData('#EditContactForm')
      if (formData.alias !== '' && formData.username !== '' && formData.label !== '') {
        if (validateIBAN(formData.iban) !== null) {
          this.$engine.firstOn().contacts
            .update({idContact: that.$settings.currentContact.id, login: formData.alias, name: formData.username, iban: formData.iban, label: formData.label})
            .then(() => {
              that.alias = ''
              that.username = ''
              that.iban = ''
              that.label = ''
              that.$f7.alert('Contact correctly changed', 'Success')
              that.$bus.$emit('refresh-cache-contacts')
              that.$f7.mainView.router.back({url: '/contacts/', force: true, ignoreCache: true})
            })
            .catch(err => {
              errorMessageAlert(err, this)
            })
          this.$f7.closeModal()
        } else {
          this.$f7.alert('', 'Iban invalid')
        }
      } else {
        this.$f7.alert('', 'Data empty')
      }
    },
    removeContact () {
      let that = this
      that.$f7.confirm('Are you sure to delete this contact?', 'Operation confirmation', function () {
        that.$engine.firstOn().contacts
        .delete(that.$settings.currentContact.id)
        .then(resp => {
          that.alias = ''
          that.username = ''
          that.$bus.$emit('refresh-cache-contacts')
          that.$f7.alert('Contact deleted', 'Operation succeeded', function () {
            that.$f7.closeModal()
          })
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    }
  }
}
</script>
